import React, { useState } from 'react';

const PAGES = [
    'https://rauxa.com',
    'https://moxieusa.com',
    'https://mry.com',
    'https://www.rauxa.com',
    'https://www.moxieusa.com',
    'https://www.mry.com',
    // '', // uncomment for testing
];

const isBrowser = () => typeof document !== 'undefined';

const isReferrerTracked = (referrer) => PAGES.findIndex((page) => referrer.startsWith(page)) !== -1;
const isRedirectQuery = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return !!urlParams.get('redirect') || urlParams.get('redirect') === '';
};

const AppContext = React.createContext();

export const AppContextProvider = ({ children }) => {
    const [showRefModal, setShowRefModal] = useState(isBrowser()
        && (isReferrerTracked(document.referrer) || isRedirectQuery()));

    return (
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        <AppContext.Provider value={{ showRefModal, setShowRefModal }}>
            {children}
        </AppContext.Provider>
    );
};

export default AppContext;
